module.exports = __webpack_public_path__ + "img/sbzc_15.088d2f9b.jpg";